import type { InspirationAlsoReadBlockDTO } from 'autogen/swagger/all';
import { ArticleBlock } from 'autogen/translation-keys/trans-root-website';
import styled from 'styled-components';
import { breakpoint, sizes } from 'variables';
import {
    FontLineHeightTight,
    FontFontFamilySecondary,
    FontSize14,
    FontWeightSemiBold
} from 'autogen/design-tokens/tokens';
import { useTranslation } from 'react-i18next';
import PictureDeprecated from 'components/generic/picture/PictureDeprecated';

export type InspirationAlsoReadPlaceholderProps = {
    model: InspirationAlsoReadBlockDTO;
};

const Container = styled.div`
    display: flex;
    flex-wrap: wrap;
    margin-right: -15px;
    margin-left: -15px;
`;

const ArticleContainer = styled.div`
    display: grid;
    grid-template-columns: 100%;
    grid-template-rows: 50% 50%;
    width: 100%;
    padding-right: 15px;
    padding-left: 15px;
    padding-bottom: 16px;

    ${breakpoint.up(sizes.sm)} {
        width: 50%;
        padding-bottom: 28px;
    }

    ${breakpoint.up(sizes.lg)} {
        width: 25%;
    }
`;

const PictureContainer = styled(PictureDeprecated)`
    & img {
        height: 100%;
        object-fit: cover;
        vertical-align: middle;
        border-radius: 8px 8px 0 0;
    }
`;

const Body = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 24px;
`;

const SectionName = styled.p`
    font-size: ${FontSize14};
    color: #000000;
    text-transform: uppercase;
    line-height: 1.2;
    letter-spacing: 0.04em;
    margin-bottom: 4px;
`;

const Title = styled.a`
    font-family: ${FontFontFamilySecondary};
    line-height: ${FontLineHeightTight};
    font-size: 2rem;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    max-height: 2.4em;
    color: #000000;
    flex: 0 1 auto;
    max-width: 100%;
    hyphens: auto;
`;

const ReadMore = styled.a`
    font-size: ${FontSize14};
    font-weight: ${FontWeightSemiBold};
    color: #000000;
    text-decoration: underline;
    margin-top: 12px;
`;

export default function MultiArticleBlock(props: InspirationAlsoReadPlaceholderProps) {
    const { model } = props;
    const { t } = useTranslation();

    return (
        <Container>
            {model.articles.map((article) => (
                <ArticleContainer key={article.id}>
                    <a href={article.url}>
                        <PictureContainer {...article.image_4x3} />
                    </a>
                    <Body>
                        <SectionName>{article.section.name}</SectionName>
                        <Title href={article.url}>{article.title}</Title>
                        <ReadMore href={article.url}>{t(ArticleBlock.ButtonText)}</ReadMore>
                    </Body>
                </ArticleContainer>
            ))}
        </Container>
    );
}
